import * as React from "react";
import type { SVGProps } from "react";
const SvgSquareArrowUp = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M15 6c-.19 0-.38-.05-.55-.17L13 4.863V14c0 .55-.45 1-1 1s-1-.45-1-1V4.88l-1.44.96c-.17.11-.36.17-.55.17L9 6c-.32 0-.64-.16-.83-.45-.31-.46-.18-1.08.28-1.39l2.903-1.926a1.01 1.01 0 0 1 1.207-.074l3 2c.46.31.58.93.28 1.39-.19.29-.51.45-.83.45z"
    />
    <path
      fill="currentColor"
      d="M4 21c0 .55.45 1 1 1h14c.55 0 1-.45 1-1V8c0-.55-.45-1-1-1h-2c-.55 0-1 .45-1 1s.45 1 1 1h1v11H6V9h1c.55 0 1-.45 1-1s-.45-1-1-1H5c-.55 0-1 .45-1 1z"
    />
  </svg>
);
export default SvgSquareArrowUp;
